/**
 * Hook for fetching calendar events belonging to a group
 */

import { useSearchCalendarEvents } from '@/features/calendarEvents/hooks/useCalendarEvents'
import { CalendarEventSearchParams, EventOwnerEntityType } from '@/api/types/calendarEvent'

/**
 * Hook to fetch calendar events for a specific group
 * Wraps useSearchCalendarEvents with group-specific filtering
 */
export function useGroupEvents(
  groupId: string,
  filters?: Partial<Omit<CalendarEventSearchParams, 'ownerEntityId' | 'ownerEntityType'>>
) {
  return useSearchCalendarEvents({
    ownerEntityId: groupId,
    ownerEntityType: EventOwnerEntityType.Group,
    ...filters,
  })
}
